export const AuthOperationErrorCode = {
  RESET_TOKEN_INVALID: "reset_token_invalid",
  RESET_TOKEN_NOT_FOUND: "reset_token_not_found",
  PASSWORD_REQUIREMENTS: "password_requirements",
  RESET_PASSWORD_FAILED: "reset_password_failed",
  RESET_EMAIL_FAILED: "reset_email_failed",
} as const;

export type AuthOperationErrorCode =
  (typeof AuthOperationErrorCode)[keyof typeof AuthOperationErrorCode];

export function resetPasswordErrorCode(status: number | undefined): AuthOperationErrorCode {
  switch (status) {
    case 400:
    case 401:
      return AuthOperationErrorCode.RESET_TOKEN_INVALID;
    case 404:
      return AuthOperationErrorCode.RESET_TOKEN_NOT_FOUND;
    case 422:
      return AuthOperationErrorCode.PASSWORD_REQUIREMENTS;
    default:
      return AuthOperationErrorCode.RESET_PASSWORD_FAILED;
  }
}

/** Mirror of `services/api/app/core/errors/codes.py` `InvestmentErrorCodes`, the codes the app reads. */
export const InvestmentErrorCode = {
  INVALID_INITIAL_STATE: "investment_invalid_initial_state",
  INVALID_STATE_TRANSITION: "investment_invalid_state_transition",
  MISSING_DOCUMENTS_FOR_STATE: "investment_missing_documents_for_state",
  TERMINATED_MODIFICATION: "investment_terminated_modification",
  DECLARED_MODIFICATION: "investment_declared_modification",
  PAYMENT_REGISTERED: "investment_payment_registered",
  CONTRACTS_UPLOADED: "investment_contracts_uploaded",
  CONTRACTS_BOUND: "investment_contracts_bound",
  INSUFFICIENT_QUOTA: "investment_insufficient_quota",
  QUOTA_RESERVE_FAILED: "investment_quota_reserve_failed",
  QUOTA_COMPLETE_FAILED: "investment_quota_complete_failed",
  QUOTA_RELEASE_FAILED: "investment_quota_release_failed",
  QUOTA_FROZEN: "investment_quota_frozen",
} as const;

export type InvestmentErrorCode = (typeof InvestmentErrorCode)[keyof typeof InvestmentErrorCode];
